import { ApiBaseServiceProvider } from './ApiBaseServiceProvider';
import axios from 'axios';

export class ImageServiceProvider extends ApiBaseServiceProvider {
  scope = 'image';

  upload = (file: File) => {
    const form = new FormData();
    form.append('file', file);

    return axios.post<{ fileName: string; url: string; signedUrl: string }>(
      this.getBaseUrl() + 'upload/',
      form,
      this.getRequestConfig()
    );
  };

  getUrl = (path: string) => {
    return axios.post<{ signedUrl: string; id: string }>(this.getBaseUrl() + 'url', { path }, this.getRequestConfig());
  };
}
